// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from "@/layout";
var operationRouter = {
  path: "/operation",
  component: Layout,
  redirect: "/operation/setting",
  name: "Operation",
  meta: {
    title: "设置",
    icon: "clipboard",
    roles: ["admin"]
  },
  children: [{
    path: "business/info",
    name: "businessInfo",
    component: function component() {
      return import("@/views/systemSetting/business/info");
    },
    meta: {
      title: "商家设置",
      icon: "clipboard"
    }
  }, {
    path: "business/allyInfo",
    name: "businessAllyInfo",
    component: function component() {
      return import("@/views/systemSetting/business/allyInfo");
    },
    meta: {
      title: "商家信息",
      icon: "clipboard"
    }
  }, {
    path: "customerservice",
    name: "customerservice",
    component: function component() {
      return import("@/views/systemSetting/customerservice");
    },
    meta: {
      title: "客服管理",
      icon: "clipboard"
    }
  }, {
    path: "staffManager",
    name: "staffManager",
    component: function component() {
      return import("@/views/systemSetting/staffManager");
    },
    meta: {
      title: "员工管理",
      icon: "clipboard"
    }
  }, {
    path: "setting",
    name: "setting",
    component: function component() {
      return import("@/views/systemSetting/setting");
    },
    meta: {
      title: "系统设置",
      icon: "clipboard"
    }
  }, {
    path: "guide",
    name: "guide",
    component: function component() {
      return import("@/views/systemSetting/guide");
    },
    meta: {
      title: "配置引导",
      icon: "clipboard"
    }
  }, {
    path: "notification",
    name: "notification",
    component: function component() {
      return import("@/views/systemSetting/notification");
    },
    meta: {
      title: "消息通知",
      icon: "clipboard"
    }
  }, {
    path: "onePass",
    name: "onePass",
    component: function component() {
      return import("@/views/sms/smsConfig");
    },
    meta: {
      title: "一号通",
      icon: "clipboard"
    }
  }, {
    path: "aliyun",
    name: "aliyun",
    component: function component() {
      return import("@/views/aliyun/aliyunsms");
    },
    meta: {
      title: "阿里云短信",
      icon: "clipboard"
    }
  }, {
    path: "roleManager",
    name: "RoleManager",
    component: function component() {
      return import("@/views/systemSetting/administratorAuthority");
    },
    meta: {
      title: "管理权限",
      icon: "clipboard",
      roles: ["admin"]
    },
    children: [{
      path: "identityManager",
      component: function component() {
        return import("@/views/systemSetting/administratorAuthority/identityManager");
      },
      name: "identityManager",
      meta: {
        title: "后台角色管理",
        icon: ""
      }
    }, {
      path: "FrontendManager",
      component: function component() {
        return import("@/views/systemSetting/administratorAuthority/FrontendManager");
      },
      name: "FrontendManager",
      meta: {
        title: "前端角色管理",
        icon: ""
      }
    }, {
      path: "adminList",
      component: function component() {
        return import("@/views/systemSetting/administratorAuthority/adminList");
      },
      name: "adminList",
      meta: {
        title: "管理员列表",
        icon: ""
      }
    }, {
      path: "promiseRules",
      component: function component() {
        return import("@/views/systemSetting/administratorAuthority/permissionRules");
      },
      name: "promiseRules",
      meta: {
        title: "权限规则",
        icon: ""
      }
    }]
  }, {
    path: "rolemenu",
    name: "rolemenu",
    component: function component() {
      return import("@/views/systemSetting/rolemenu");
    },
    meta: {
      title: "角色菜单表",
      roles: ["admin"]
    },
    children: [{
      path: "configureRoles",
      component: function component() {
        return import("@/views/systemSetting/rolemenu/configureRoles");
      },
      name: "configureRoles",
      meta: {
        title: "配置角色表",
        icon: ""
      }
    }, {
      path: "Nobusiness",
      component: function component() {
        return import("@/views/systemSetting/rolemenu/Nobusiness");
      },
      name: "Nobusiness",
      meta: {
        title: "非商圈组织",
        icon: ""
      }
    }, {
      path: "Designercircle",
      component: function component() {
        return import("@/views/systemSetting/rolemenu/Designercircle");
      },
      name: "Designercircle",
      meta: {
        title: "设计商圈组织",
        icon: ""
      }
    }, {
      path: "Smallshopcircle",
      component: function component() {
        return import("@/views/systemSetting/rolemenu/Smallshopcircle");
      },
      name: "Smallshopcircle",
      meta: {
        title: "小店商圈组织",
        icon: ""
      }
    }]
  }, {
    path: "systemSms",
    component: function component() {
      return import("@/views/sms");
    },
    name: "systemSms",
    meta: {
      title: "短信设置",
      icon: "clipboard",
      roles: ["admin"]
    },
    children: [{
      path: "config",
      component: function component() {
        return import("@/views/sms/smsConfig");
      },
      name: "SmsConfig",
      meta: {
        title: "短信账户",
        noCache: true
      }
    }, {
      path: "template",
      component: function component() {
        return import("@/views/sms/smsTemplate");
      },
      name: "SmsTemplate",
      meta: {
        title: "短信模板",
        noCache: true,
        activeMenu: "/operation/onePass"
      }
    }, {
      path: "pay",
      component: function component() {
        return import("@/views/sms/smsPay");
      },
      name: "SmsPay",
      meta: {
        title: "短信购买",
        noCache: true,
        activeMenu: "/operation/onePass"
      }
    }, {
      path: "message",
      component: function component() {
        return import("@/views/sms/smsMessage");
      },
      name: "SmsMessage",
      meta: {
        title: "短信开关",
        noCache: true
      }
    }]
  }, {
    path: "design",
    name: "design",
    alwaysShow: true,
    component: function component() {
      return import("@/views/systemSetting/design");
    },
    meta: {
      title: "页面管理",
      roles: ["admin"]
    },
    children: [{
      path: "viewDesign",
      component: function component() {
        return import("@/views/systemSetting/design/viewDesign");
      },
      name: "viewDesign",
      meta: {
        title: "页面设计",
        noCache: true
      }
    }, {
      path: "theme",
      component: function component() {
        return import("@/views/systemSetting/design/theme");
      },
      name: "theme",
      meta: {
        title: "一键换色",
        noCache: true
      }
    }]
  }, {
    path: "deliverGoods",
    name: "deliverGoods",
    alwaysShow: true,
    component: function component() {
      return import("@/views/systemSetting/deliverGoods");
    },
    meta: {
      title: "发货设置",
      roles: ["admin"]
    },
    children: [{
      path: "takeGoods",
      component: function component() {
        return import("@/views/systemSetting/deliverGoods/takeGoods");
      },
      name: "takeGoods",
      meta: {
        title: "提货设置",
        noCache: true,
        roles: ["admin"]
      },
      children: [{
        path: "deliveryAddress",
        component: function component() {
          return import("@/views/systemSetting/deliverGoods/takeGoods/deliveryAddress");
        },
        name: "deliveryAddress",
        meta: {
          title: "提货点",
          icon: ""
        }
      }, {
        path: "collateOrder",
        component: function component() {
          return import("@/views/systemSetting/deliverGoods/takeGoods/collateOrder");
        },
        name: "collateOrder",
        meta: {
          title: "核销订单",
          icon: ""
        }
      }, {
        path: "collateUser",
        component: function component() {
          return import("@/views/systemSetting/deliverGoods/takeGoods/collateUser");
        },
        name: "collateUser",
        meta: {
          title: "核销员",
          icon: ""
        }
      }]
    }, {
      path: "freightSet",
      component: function component() {
        return import("@/views/systemSetting/deliverGoods/freightSet");
      },
      name: "freightSet",
      meta: {
        title: "运费模板",
        noCache: true
      }
    }, {
      path: "areaTemplate",
      component: function component() {
        return import("@/views/systemSetting/deliverGoods/areaTemplate");
      },
      name: "areaTemplate",
      meta: {
        title: "可售区域",
        noCache: true
      }
    }]
  }, {
    path: "cloudDesktop",
    name: "cloudDesktop",
    component: function component() {
      return import("@/views/systemSetting/cloudDesktop");
    },
    meta: {
      title: "海马云桌面",
      roles: ["admin"],
      icon: "clipboard"
    }
  }]
};
export default operationRouter; //collate